import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Alert, Box } from "@curves/ui-base";
import { useMemberDetailContext } from "@icoach/memberDetail/MemberDetailContext";
import useMessageDialog from "@util/hook/useMessageDialog";
import CreditCardPayment from "@icoach/memberDetail/components/CreditCardPayment";
import BankPayment from "@icoach/memberDetail/components/BankPayment";
import { isEqual, isFunction } from "@util/utils";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";
import { PAYMENT_TYPE } from "@icoach/constants";

const MemberDetailBasicInfoContentPayment = (props) => {
	const { memberID } = props;
	const setMessageDialog = useMessageDialog();
	const { setRefresh, dialogRef } = useMemberDetailContext();
	const { getMemberProfilePaymentsApi } = useMemberProfileApi();
	const [paymentList, setPaymentList] = useState([]);
	const { openMultiplePaymentDialog, openViewPaymentDialog, openPaymentHistoryDialog } = dialogRef.current || {};

	const doMemberProfilePaymentsApi = async (memberID) => {
		let resp = await getMemberProfilePaymentsApi(memberID);
		if (resp) {
			setPaymentList(resp);
		}
	};

	const handleEdit = (targetData) => () => {
		if (isEqual(targetData?.sourceType, 4)) {
			setMessageDialog({
				open: true,
				title: "提醒",
				msg: "請透過健康產品變更單申請變更資料，謝謝"
			});
		} else {
			isFunction(openMultiplePaymentDialog) && openMultiplePaymentDialog(
				{
					...targetData,
					memberID
				},
				() => doMemberProfilePaymentsApi(memberID));
		}
	};

	useEffect(
		() => {
			if (memberID) {
				setRefresh(doMemberProfilePaymentsApi);
				doMemberProfilePaymentsApi(memberID);
			}
		},
		// eslint-disable-next-line
		[memberID]
	);

	return (
		<Box className="mb-4">
			<Grid container spacing={2}>
				<Grid xs={12} item>
					<Alert color="info" severity="info" variant="filled">
						<Box className={'mb-1'}>每筆付款資料皆為獨立授權，請依需求逐筆查看與更新。</Box>
						<Box>健康產品的付款資料僅供查閱，如需變更，請使用『健康產品變更單』進行申請。</Box>
					</Alert>
				</Grid>
				{Array.isArray(paymentList) &&
					paymentList.map((item, i) => {
						const { paymentType } = item || {};

						switch (paymentType) {
							case PAYMENT_TYPE.CREDITCARD: // 信用卡
								const actions = [
									{
										text: "查看",
										onClick: () => {
											openViewPaymentDialog({
												...item,
												memberID,
												onEdit: handleEdit(item)
											});
										}
									},
									{
										text: "歷史",
										onClick: () => {
											openPaymentHistoryDialog({
												...item,
												memberID,
											})
										}
									},
									{
										text: "新增變更單",
										onClick: handleEdit(item)
									}
								];
								return (
									<Grid key={item.memberPaymentID} xs={6} xl={4} item>
										<CreditCardPayment sourceData={item} actions={actions} />
									</Grid>
								);

							case PAYMENT_TYPE.ACH: // 銀行帳戶
								return (
									<Grid key={item.memberPaymentID} xs={6} xl={4} item>
										<BankPayment sourceData={item} onEdit={handleEdit(item, i)} />
									</Grid>
								);

							default: // 其他付款方式
								return null;
						}
					})}
			</Grid>
		</Box>
	);
};

export default MemberDetailBasicInfoContentPayment;
